export const DELETE_PLC_SAFETY_EVENT = 'DELETE_PLC_SAFETY_EVENT';
export const DELETE_PLC_SAFETY_EVENT_SUCCESSFUL = 'DELETE_PLC_SAFETY_EVENT_SUCCESSFUL';
export const DELETE_PLC_SAFETY_EVENT_FAILED = 'DELETE_PLC_SAFETY_EVENT_FAILED';
